export enum BackgroundTheme {
  LIGHT = 'light',
  GREY = 'grey',
  PALE_GOLD = 'pale gold',
}

export enum TextBackgroundTheme {
  LIGHT = 'light',
  GREY = 'grey',
  MIXED = 'mixed',
}

export enum HighlightsBackgroundTheme {
  LIGHT_GREEN = 'light green',
  LIGHT = 'light',
  GREY = 'grey',
  PALE_GOLD = 'pale gold',
}

export enum BannerTextBackgroundTheme {
  LIGHT = 'light',
  BLUE = 'blue',
}

export enum CarouselItemsBackgroundTheme {
  PLUM = 'plum',
  DARK_GREEN = 'dark_green',
}

export enum IconTheme {
  PLUM = 'plum',
  GREEN = 'green',
  GREY = 'grey',
}

export enum TrialBackgroundTheme {
  WHITE = 'white',
}
